<template>
  <div class="activity-bar-graph-container">
    <div class="activity-bar-graph-main">
      <div class="activity-bar-graph" ref="style" style="width:100%;height:0px"/>
      <div class="activity-bar-graph-alt" ref="altStyle" style="width:0px;height:0px"/>
      <vue-bar-graph
        :points="graphData"
        :show-x-axis="true"
        :show-y-axis="false"
        :show-values="true"
        :width="graphWidth"
        :bar-color="colors.barColor"
        :text-color="colors.textColor"
        :text-alt-color="colors.textAltColor"
        :height="150"
        :label-height="32"
        text-font="12px sans-serif"
      >
        <template #label="opt">
          <g v-for="(author, idx) in authors" :key="author.position">
            <defs>
              <rect id="rect" x="25%" y="25%" width="50%" height="50%" rx="15"/>
              <clipPath id="clip">
                <use xlink:href="#rect"/>
              </clipPath>
            </defs>
            <a
              v-if="opt.bar.index === idx && author.home_link !== ''"
              :href="author.home_link"
            >
              <foreignObject
                :x="`${opt.bar.midPoint - avatarWidth / 2}px`"
                :y="`${opt.bar.yLabel}px`"
                :height="`${avatarWidth}`"
                :width="`${avatarWidth}`"
              >
                <img
                  class="avatar"
                  :height="`${avatarWidth}`"
                  :width="`${avatarWidth}`"
                  :src="author.avatar_link"
                >
              </foreignObject>
            </a>
            <foreignObject
              v-else-if="opt.bar.index === idx"
              :x="`${opt.bar.midPoint - avatarWidth / 2}px`"
              :y="`${opt.bar.yLabel}px`"
              :height="`${avatarWidth}`"
              :width="`${avatarWidth}`"
            >
              <img
                class="avatar"
                :height="`${avatarWidth}`"
                :width="`${avatarWidth}`"
                :src="author.avatar_link"
              >
            </foreignObject>
          </g>
        </template>
        <template #title="opt">
          <tspan v-for="(author, idx) in authors" :key="author.position">
            <tspan v-if="opt.bar.index === idx">
              {{ author.name }}
            </tspan>
          </tspan>
        </template>
      </vue-bar-graph>
    </div>

    <div v-if="extraCount > 0" class="activity-bar-graph-extra">
      <div>
        +{{ extraCount }}
      </div>
      <div>
        others
      </div>
    </div>
  </div>
</template>
<script>
import {VueBarGraph} from 'vue-bar-graph';
const activityTopAuthors = window.config.pageData.repoActivityTopAuthors || [];
export default {
  components: {VueBarGraph},
  props: {
    data: {type: Array, default: () => []},
  },
  data: () => ({
    isMounted: false,
    maxCount: 15,
    avatarWidth: 32,
    colors: {
      barColor: 'green',
      textColor: 'black',
      textAltColor: 'white',
    },
  }),
  computed: {
    graphData() {
      return activityTopAuthors.slice(0, 15).map((item) => {
        return {
          value: item.commits,
          label: item.name,
        };
      });
    },
    authors() {
      return activityTopAuthors.map((item, idx) => {
        return {
          position: idx + 1,
          ...item,
        };
      });
    },
    graphWidth() {
      if (!this.isMounted) {
        return 80;
      }
      return this.$refs.style.clientWidth;
    },
    extraCount() {
      return activityTopAuthors.length - this.maxCount;
    }
  },
  mounted() {
    const st = window.getComputedStyle(this.$refs.style);
    const stalt = window.getComputedStyle(this.$refs.altStyle);
    this.isMounted = true;

    this.colors.barColor = st.backgroundColor;
    this.colors.textColor = st.color;
    this.colors.textAltColor = stalt.color;
  },
  methods: {
    hasHomeLink(i) {
      return this.graphData[i].homeLink !== '' && this.graphData[i].homeLink !== null;
    },
  }
};
</script>
